import {
  counselDesignItemsInitData,
  DESIGN_ITEM_CATEGORY3,
  designFacilityData,
  FACILITY_TYPE,
  facilityData,
  INBOUND_COUNSEL_INTERNAL,
  TRANSACTION_METHOD,
} from "@constants/inbound";
import { cloneDeep } from "lodash-es";
import { useAtom } from "jotai";
import { hcostInboundAtom } from "@/store/hcost-atom";
import { useCallback, useState } from "react";
import { getCounselDesignModel } from "@service/counsel/counsel-model-service";
import { getHCostResultInbound } from "@service/hcost/hcost-result-service";
import { HCOST_INBOUND_DATA } from "@constants/hcost/hcost-data";

function useCounselHook() {
  const [hCostResult, setHCostResult] = useAtom(hcostInboundAtom);
  const setDesignItemsDefaultValue = (code: string) => {
    const dataFieldClone: any[] = [];
    const item = designFacilityData.find((v: any) => v[code]);
    if (item) {
      // @ts-ignore
      item[code].map((i: any) => {
        i.children.map((c: any) => {
          if (c.selected) {
            if (code === FACILITY_TYPE.WAREHOUSE || code === FACILITY_TYPE.SINGLE) {
              if (
                i.category2 === DESIGN_ITEM_CATEGORY3.WINDOW ||
                i.category2 === DESIGN_ITEM_CATEGORY3.GATE_FRONT ||
                i.category2 === DESIGN_ITEM_CATEGORY3.GATE_BACK
              ) {
                dataFieldClone.push({
                  category2: { code: i.category2 },
                  itemNumber: c.code,
                  itemCount: 1,
                  num1: 2,
                  enabled: true,
                });
              } else {
                dataFieldClone.push({
                  category2: { code: i.category2 },
                  itemNumber: c.code,
                  itemCount: 1,
                  enabled: true,
                });
              }
            } else {
              if (i.category2 === DESIGN_ITEM_CATEGORY3.GATE_FRONT || i.category2 === DESIGN_ITEM_CATEGORY3.GATE_BACK) {
                dataFieldClone.push({
                  category2: { code: i.category2 },
                  itemNumber: c.code,
                  itemCount: 1,
                  num1: 2,
                  num2: 1,
                  enabled: true,
                });
              } else {
                dataFieldClone.push({
                  category2: { code: i.category2 },
                  itemNumber: c.code,
                  itemCount: 1,
                  enabled: true,
                });
              }
            }
          }
        });
      });
      return dataFieldClone;
    }
  };
  const setDesignItemsDefaultValue_V2 = (code: string) => {
    const dataFieldClone: any[] = [];
    const item = facilityData[code];
    if (item) {
      item.map((c1: any) => {
        c1.category2.map((c2: any) => {
          if (c2.selected) {
            dataFieldClone.push({ category2: { code: c2.value }, itemNumber: c2.code, itemCount: 1, enabled: true });
          }
          c2.category3?.map((c3: any) => {
            c3.items?.map((i: any) => {
              if (i.selected) {
                if (code === FACILITY_TYPE.WAREHOUSE || code === FACILITY_TYPE.SINGLE) {
                  if (
                    c3.value === DESIGN_ITEM_CATEGORY3.WINDOW ||
                    c3.value === DESIGN_ITEM_CATEGORY3.GATE_FRONT ||
                    c3.value === DESIGN_ITEM_CATEGORY3.GATE_BACK
                  ) {
                    dataFieldClone.push({
                      category3: { code: c3.value },
                      itemNumber: i.code,
                      itemCount: 1,
                      num1: 2,
                      enabled: true,
                    });
                  } else {
                    dataFieldClone.push({
                      category3: { code: c3.value },
                      itemNumber: i.code,
                      itemCount: 1,
                      enabled: true,
                    });
                  }
                } else {
                  if (c3.value === DESIGN_ITEM_CATEGORY3.GATE_FRONT || c3.value === DESIGN_ITEM_CATEGORY3.GATE_BACK) {
                    dataFieldClone.push({
                      category3: { code: c3.value },
                      itemNumber: i.code,
                      itemCount: 1,
                      num1: 2,
                      num2: 1,
                      enabled: true,
                    });
                  } else {
                    dataFieldClone.push({
                      category3: { code: c3.value },
                      itemNumber: i.code,
                      itemCount: 1,
                      enabled: true,
                    });
                  }
                }
              }
            });
          });
        });
      });
      return dataFieldClone;
    } else {
      return dataFieldClone;
    }
  };

  // 시설 유형 전체 데이터에 초기값 세팅
  const setDesignItemsInit = (compare: any) => {
    const result = cloneDeep(counselDesignItemsInitData).map((init: any) => {
      compare.map((c: any) => {
        if (init.itemNumber === c.itemNumber) {
          init.enabled = c.selected;
          c.num1 ? (init.num1 = c.num1) : (init.num1 = null);
          c.num2 ? (init.num2 = c.num2) : (init.num2 = null);
        }
      });
      return init;
    });
    return result;
  };

  const setDesignItemsInit_V2 = (data: CounselModelItem[], code: string, compare?: any) => {
    const result = data.map((v: any) => {
      let y: any = { ...v };
      y["enabled"] = v["selected"];
      if (
        v.category3.code === DESIGN_ITEM_CATEGORY3.GATE_FRONT ||
        v.category3.code === DESIGN_ITEM_CATEGORY3.GATE_BACK ||
        v.category3.code === DESIGN_ITEM_CATEGORY3.WINDOW
      ) {
        y.num1 = 2;
        if (code === FACILITY_TYPE.VENLO || code === FACILITY_TYPE.INTERLOCK) {
          y.num2 = 1;
        }
      }
      if (compare) y.enabled = false;
      return y;
    });

    if (compare) {
      result.map((init: any) => {
        const data = compare.find((v: any) => v.itemNumber === init.itemNumber);
        if (data) {
          init.enabled = data.enabled;
          data.num1 ? (init.num1 = data.num1) : (init.num1 = null);
          data.num2 ? (init.num2 = data.num2) : (init.num2 = null);
        }
      });
    }
    return result;
  };
  const onValueChangeCounselHandler = useCallback(
    (set: (draft: any, value: any) => void) => (e: any) => {
      if (!e.event) return;
      setHCostResult((draft: any) => {
        set(draft, e.value);
      });
    },
    [setHCostResult],
  );

  const handleRadioChecked = (set: (draft: any, value: any) => void) => (e: any) => {
    setHCostResult((draft: any) => {
      set(draft, e.target.value);
    });
  };

  /** 설계 모델과 비교하여 초기값 세팅 */
  const initCounselDesignItems = (
    data: CounselModel,
    facilityCode: string,
    counselDesignItems?: CounselDesignItem[],
  ) => {
    setHCostResult(prev => {
      prev.counselDesigns[0].counselDesignItems = setDesignItemsInit_V2(
        data.designModelItems,
        facilityCode,
        counselDesignItems,
      );
    });
  };

  /** 설계 모델 조회 */
  const getDesignModel = useCallback(
    (code: string, counselDesignItems?: CounselDesignItem[]) => {
      if (!code) return;
      getCounselDesignModel(code).then((res: CounselModel) => {
        initCounselDesignItems(res, code, counselDesignItems);
      });
    },
    [setHCostResult],
  );

  const getHCostCounsel = useCallback(
    async (id: number, accessType: string, selectedIndex: number) => {
      try {
        const counselResult = await getHCostResultInbound(id, accessType);
        getDesignModel(
          counselResult.counselDesigns[selectedIndex].facilityType?.code,
          counselResult.counselDesigns[selectedIndex].counselDesignItems,
        );
        setHCostResult({
          ...counselResult,
          counselContentsInternal:
            counselResult.counselContentsInternal !== null
              ? counselResult.counselContentsInternal
              : INBOUND_COUNSEL_INTERNAL,
          transactionMethod: !counselResult.transactionMethod
            ? { code: TRANSACTION_METHOD.MATERIALS_CONSTRUCTION, value: "자재+시공" }
            : counselResult.transactionMethod,
          counselDesigns: !!counselResult.counselDesigns.length
            ? counselResult.counselDesigns
            : HCOST_INBOUND_DATA.counselDesigns,
        });
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    [getDesignModel, setHCostResult],
  );

  return {
    setDesignItemsDefaultValue,
    setDesignItemsDefaultValue_V2,
    setDesignItemsInit,
    setDesignItemsInit_V2,
    onValueChangeCounselHandler,
    handleRadioChecked,
    initCounselDesignItems,
    getDesignModel,
    getHCostCounsel,
  };
}

export default useCounselHook;
